// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'laptop-solid';

export const Component = () => (
  <path d='M24.521 17.752h-.958V4.485c0-.431-.143-.766-.431-1.054A1.408 1.408 0 0 0 22.078 3H2.442c-.431 0-.766.144-1.005.431-.288.288-.432.623-.48 1.054v13.267H0v.478c0 .67.24 1.246.719 1.725.48.479 1.054.718 1.724.718h19.636c.67 0 1.245-.239 1.724-.718.479-.48.719-1.054.719-1.725v-.478ZM22.558 4.485v13.267h-7.855v.957H9.818v-.957H1.963V4.485c0-.335.144-.479.48-.479h19.635c.335 0 .479.144.479.48Z' />
);

export const viewBox = '0 0 25 25';
